import { createTheme } from '@mui/material/styles';

const theme = createTheme(
  {
    palette: {
      primary: {
        main: '#0a335c',
        contrastText: 'white',
      },
      secondary: {
        main: '#f1654f',
      },
      background: {
        default: '#FFFFFF',
      },
      neutral: {
        main: '#e6e6e6'
      },
      status: {
        danger: {
          main: '#da1414',
        },
      },
    },
    typography: {
      h1: {
        fontSize: 20,
      },
      h2: {
        fontSize: 30,
      },
      h3: {
        fontSize: 20,
      },
    },
    components: {
      MuiTableCell: {
        styleOverrides: {
          head: ({ theme }) => ({
            'color': theme.palette.primary.contrastText,
            'backgroundColor': theme.palette.primary.main,
          })
        }
      },
      MuiAvatar: {
        styleOverrides: {
          img: {
            width: '100%',
            height: '100% !important',
          }
        }
      }
    }
  },
);

export default theme;
